import { useSession } from '~Session';
import { usePaginate, useResult } from '@rails/document/hooks';
import { useSelection } from '@react-hooks/use-selection';

import { FriendshipContext } from './FriendshipContext';
import Friendship from './Friendship';

const PER_PAGE = 20;

const Friendships = ({ children }) => {
  const { userId } = useSession();

  const fetcher = usePaginate({ per: PER_PAGE }, 'friendships', {
    where: { userId },
    includes: ['friend'],
  });

  const friendships = useResult(fetcher);

  const { isSelected, selected, toggle } = useSelection({
    data: friendships,
    multiple: false,
  });

  return (
    <FriendshipContext.Provider value={selected}>
      <div className='flex flex-row'>
        {friendships.map((f) => (
          <Friendship
            key={f.id}
            friendship={f}
            selected={isSelected(f)}
            onClick={() => toggle(f)}
          />
        ))}
      </div>
      <div className='overflow-auto'>{children}</div>
    </FriendshipContext.Provider>
  );
};

export default Friendships;
